import {
  CircularProgress,
  Typography,
  Box,
  FormControl,
  Autocomplete,
  TextField,
} from '@mui/material';
import {
  Controller,
  type Control,
  type FieldErrors,
  type UseFormRegister,
} from 'react-hook-form';
import { useListPipelines, type FlowgatePipeline } from '@/api/flowgate';
import { type BatchSchema } from '@/zod_schemas';

interface IPipelineComponentProps {
  register: UseFormRegister<BatchSchema>;
  errors: FieldErrors<BatchSchema>;
  control: Control<BatchSchema>;
  index: number;
}
type ComponentProps = IPipelineComponentProps;

const PipelineComponent = ({ errors, control, index }: ComponentProps) => {
  const { data, isLoading, isError, error } = useListPipelines();
  const pipelines = data;

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return (
      <Box>
        <Typography variant="h6" color="error">
          Error fetching data: {error?.message}
        </Typography>
      </Box>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Controller
        name={`experiments.${index}.flowgate_pipeline_ids`}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            multiple
            options={pipelines}
            getOptionLabel={(option: FlowgatePipeline) => option.name}
            value={
              Array.isArray(value)
                ? pipelines.filter((pipeline) => value.includes(pipeline.id))
                : []
            }
            onChange={(_event, newValue) => {
              onChange(newValue ? newValue.map((pipeline) => pipeline.id) : []);
            }}
            isOptionEqualToValue={(option, valueOption) =>
              option.name === valueOption.name
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Pipeline"
                error={!!errors.experiments?.[index]?.flowgate_pipeline_ids}
                helperText={
                  errors.experiments?.[index]?.flowgate_pipeline_ids
                    ? errors.experiments?.[index]?.flowgate_pipeline_ids
                        ?.message
                    : null
                }
              />
            )}
          />
        )}
      />
    </FormControl>
  );
};

export default PipelineComponent;
